import { Fieldset, type FieldsetProps, Stack } from "@mantine/core"

export function FormFieldSet({ children, ...props }: FieldsetProps) {
  return (
    <Fieldset w="100%" {...props}>
      <Stack>{children}</Stack>
    </Fieldset>
  )
}
